import { sha1 } from 'object-hash';

export function getObjectHash(object: any) {
  return sha1(object);
}
